import { render, staticRenderFns } from "./sparePartInfo.vue?vue&type=template&id=1888a68f&scoped=true"
import script from "./sparePartInfo.vue?vue&type=script&lang=js"
export * from "./sparePartInfo.vue?vue&type=script&lang=js"
import style0 from "./sparePartInfo.vue?vue&type=style&index=0&id=1888a68f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1888a68f",
  null
  
)

export default component.exports